import { render, staticRenderFns } from "./schedules-user.vue?vue&type=template&id=d58dc484&scoped=true&"
import script from "./schedules-user.vue?vue&type=script&lang=ts&"
export * from "./schedules-user.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58dc484",
  null
  
)

export default component.exports